import { render, staticRenderFns } from "./FamilyLogs.vue?vue&type=template&id=5840a1ef&scoped=true"
import script from "./FamilyLogs.ts?vue&type=script&lang=ts&external"
export * from "./FamilyLogs.ts?vue&type=script&lang=ts&external"
import style0 from "./FamilyLogs.vue?vue&type=style&index=0&id=5840a1ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840a1ef",
  null
  
)

export default component.exports